export const DEFAULT_DRAWER_WIDTH = 400;
